<template>
  <div class="card m-0 flex">
    <div class="w-1/2 px-4 pt-2 pb-4">
      <h3
        class="m-0 mb-2"
        v-text="'Filter'"
      />
      <div v-can="'view-blog-entries'">
        <input
          id="blogEntry"
          v-model="types"
          type="checkbox"
          name="blogEntry"
          value="blog-entries"
        >
        <label
          for="blogEntry"
          v-text="'Blog Entry'"
        />
      </div>
      <div v-can="'view-email'">
        <input
          id="email"
          v-model="types"
          type="checkbox"
          name="email"
          value="emails"
        >
        <label
          for="email"
          v-text="'Email'"
        />
      </div>
      <div v-can="'view-sms'">
        <input
          id="sms"
          v-model="types"
          type="checkbox"
          name="sms"
          value="sms"
        >
        <label
          for="sms"
          v-text="'Text Message'"
        />
      </div>
    </div>
    <div class="w-1/2 px-4 pt-2 pb-4">
      <h3
        class="m-0 mb-2"
        v-text="'Sort'"
      />
      <div v-can="'view-blog-entries'">
        <input
          id="sort_asc"
          v-model="sortDirection"
          type="radio"
          value="asc"
        >
        <label
          for="sort_asc"
          v-text="'Ascending'"
        />
        <input
          id="sort_desc"
          v-model="sortDirection"
          type="radio"
          value="desc"
        >
        <label
          for="sort_desc"
          v-text="'Descending'"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'CommunicationsStatusFilter',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sortDirection: 'desc',
    }
  },
  computed: {
    types: {
      get() {
        return this.value
      },
      set(types) {
        this.$emit('input', types)
      },
    },
  },
}
</script>
